/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LogInterviewResult
 */
export interface LogInterviewResult {
  /**
   *
   * @type {string}
   * @memberof LogInterviewResult
   */
  applicationInterviewId: string;
}

/**
 * Check if a given object implements the LogInterviewResult interface.
 */
export function instanceOfLogInterviewResult(
  value: object,
): value is LogInterviewResult {
  if (
    !("applicationInterviewId" in value) ||
    value["applicationInterviewId"] === undefined
  )
    return false;
  return true;
}

export function LogInterviewResultFromJSON(json: any): LogInterviewResult {
  return LogInterviewResultFromJSONTyped(json, false);
}

export function LogInterviewResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LogInterviewResult {
  if (json == null) {
    return json;
  }
  return {
    applicationInterviewId: json["applicationInterviewId"],
  };
}

export function LogInterviewResultToJSON(json: any): LogInterviewResult {
  return LogInterviewResultToJSONTyped(json, false);
}

export function LogInterviewResultToJSONTyped(
  value?: LogInterviewResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationInterviewId: value["applicationInterviewId"],
  };
}
